import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Icon, Input, Button } from 'antd';
import zmailLogo from '../img/zmail_logo.png';

import authenticateUser from '../authentication/authenticateUser';
import resetFunctions from '../authentication/resetPassword';
import '../combinedStyles';

import UsersService from '../services/userService';

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      schoolName: '',
      verificationCode: '',
      newPassword: '',
      confirmNewPassword: '',
      loginStatus: '',
      stage: 'resetPassword',
    };
  }

  componentWillMount() {
    this.setState({
      username: this.props.username,
      schoolName: this.props.schoolName,
      stage: this.props.stage,
    });
  }

  handleUsernameChange(event) {
    var newValue = event.target.value;
    this.setState({
      username: newValue,
    });
  }

  handleSchoolNameChange(event) {
    var newValue = event.target.value;
    this.setState({
      schoolName: newValue,
    });
  }

  handleVerificationCodeChange(event) {
    var newValue = event.target.value;
    this.setState({
      verificationCode: newValue,
    });
  }

  handleNewPasswordChange(event) {
    var newValue = event.target.value;
    this.setState({
      newPassword: newValue,
    });
  }

  handleConfirmPasswordChange(event) {
    var newValue = event.target.value;
    this.setState({
      confirmNewPassword: newValue,
    });
  }

  handleKeyDown(event) {
    if (event.keyCode == 13) document.getElementById('loginBtn').click();
  }

  handleSubmit() {
    this.setState({ loginStatus: <Icon type='loading' /> }, async () => {
      switch (this.state.stage) {
        case 'resetPassword':
          await this.handleResetPassword();
          break;
        case 'confirmPassword':
          await this.handleConfirmPassword();
          break;
        default:
          console.error('ResetPassword component has an invalid stage state.');
          break;
      }
    });
  }

  async handleResetPassword() {
    if (this.state.username.length == 0 || this.state.schoolName.length == 0) {
      this.setState({ loginStatus: '* Please enter your username and/or school name' });
    } else {
      try {
        const res = await resetFunctions.startPasswordRecovery(this.state.username);

        this.setState({
          stage: 'confirmPassword',
          loginStatus: '',
        });
      } catch (err) {
        let errorMessage = err.message;
        console.error(errorMessage);
        this.setState({ loginStatus: errorMessage });
      }
    }
  }

  async handleConfirmPassword() {
    if (this.state.verificationCode.length == 0) {
      this.setState({ loginStatus: '* Please enter the verification code sent to your email' });
    } else if (this.state.newPassword.length == 0) {
      this.setState({ loginStatus: '* Please enter your new password' });
    } else if (this.state.newPassword !== this.state.confirmNewPassword) {
      this.setState({
        loginStatus:
          '* The confirmed new password does not match the new password you typed above!',
      });
    } else {
      try {
        const res = await UsersService.newPassword(
          this.state.username,
          this.state.verificationCode,
          this.state.confirmNewPassword
        );

        window.location = '/dashboard';
      } catch (err) {
        let errorMessage = err.message;

        this.setState({ loginStatus: errorMessage });
      }
    }
  }

  render() {
    let statusStyle = {
      color: 'red',
    };

    if (this.state.stage == 'resetPassword') {
      return (
        <div id='loginDiv' className='loginPage' onKeyDown={this.handleKeyDown.bind(this)}>
          <div className='form forgotPassDiv' style={{ color: 'black' }}>
            <img src={zmailLogo} className='forgotPassLogo' alt='Zmail Logo' />
            <Input
              id='username'
              type='text'
              placeholder='Username'
              onChange={this.handleUsernameChange.bind(this)}
              value={this.state.username}></Input>
            <p style={statusStyle}>{this.state.loginStatus}</p>
            <Button id='loginBtn' onClick={this.handleSubmit.bind(this)}>
              Send Recovery Code
            </Button>
            <p className='message'>
              Need Help?{' '}
              <a href='mailto:info@zcruit.com?Subject=Zcruit:%20Forgotten%20Password'>Contact us</a>
            </p>
          </div>
        </div>
      );
    } else {
      return (
        <div id='loginDiv' className='loginPage' onKeyDown={this.handleKeyDown.bind(this)}>
          <div className='form forgotPassDiv' style={{ color: 'black' }}>
            <img src={zmailLogo} className='forgotPassLogo' alt='Zmail Logo' />
            <p className='messageCheckEmail'>Check your email for your verification code</p>
            <Input
              id='username'
              type='text'
              placeholder='Username'
              value={this.state.username}
              disabled={true}></Input>
            <Input
              id='verificationCode'
              type='text'
              placeholder='Verification Code'
              onChange={this.handleVerificationCodeChange.bind(this)}
              value={this.state.verificationCode}></Input>
            <Input
              id='newPassword'
              type='password'
              placeholder='New Password'
              onChange={this.handleNewPasswordChange.bind(this)}
              value={this.state.newPassword}></Input>
            <Input
              id='confirmNewPassword'
              type='password'
              placeholder='Confirm Password'
              onChange={this.handleConfirmPasswordChange.bind(this)}
              value={this.state.confirmNewPassword}></Input>
            <p style={statusStyle}>{this.state.loginStatus}</p>
            <Button id='loginBtn' onClick={this.handleSubmit.bind(this)}>
              Confirm New Password
            </Button>
            <p className='message'>
              Need Help?{' '}
              <a href='mailto:info@zcruit.com?Subject=Zcruit:%20Forgotten%20Password'>Contact us</a>
            </p>
          </div>
        </div>
      );
    }
  }
}

export default connect()(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/ResetPassword.js